export const PLANS_ENDPOINT = '/plans';
export const BEST_PLANS_ENDPOINT = '/best-plans';
export const BEST_PRICE_ENDPOINT = '/plans/best-price';
